import { Button, SaveButton } from '@ui/shared/Button';
import { User, updateEmail } from 'firebase/auth';
import { HttpsCallableResult } from 'firebase/functions';
import * as React from 'react';
import { getErrorMessage } from '../../../constants/firebase-auth-errors';
import { currentUser } from '../../../data/providers/userProvider';
import { updateProfileEmail } from '../../../data/writers/userManagement';
import { Row } from '../../layout/Row';
import { FormSection } from '../../reports/utils/settings/FormSection';
import { ControlSpacer } from '../../shared/form/ControlSpacer';
import { ErrorMessage, SuccessMessage } from '../../shared/form/ErrorMessage';
import { TextField } from '../../shared/form/TextField';
import { LinearLoading } from '../../shared/loading/LinearLoading';

interface IEmailProps {
  user: User;
}

export const Email = (props: IEmailProps): React.ReactElement => {
  const [error, setError] = React.useState<string>('');
  const [email, setEmail] = React.useState<string>(props.user?.email ?? '');
  const [saving, setSaving] = React.useState<boolean>(false);
  const [success, setSuccess] = React.useState<boolean>(false);

  React.useEffect((): void => {
    setEmail(props.user?.email ?? '');
  }, [props.user]);

  const submitChange = (): void => {
    setSaving(true);
    /// update the email in firebase auth
    updateEmail(currentUser(), email)
      /// update the email in the users profile in firestore
      .then((): Promise<HttpsCallableResult> => updateProfileEmail(email))
      .then((): void => {
        setSuccess(true);
        setSaving(false);
      })
      .catch((err: { code: string }): void => {
        setError(getErrorMessage(err.code));
        setSaving(false);
      });
  };

  return (
    <FormSection>
      <h5>Basic Info</h5>
      <hr style={{ margin: 0 }} />
      {saving && <LinearLoading />}
      <Row>
        <div>
          <ControlSpacer>
            <TextField
              name='email'
              label='Account Email'
              type='text'
              value={email}
              placeholder='Enter your email address...'
              onChange={setEmail}
            />
          </ControlSpacer>
          <SaveButton
            type='submit'
            onClick={submitChange}
            style={{ marginLeft: '0px', marginTop: '10px' }}
          />
          {error && <ErrorMessage>{error}</ErrorMessage>}
          {success && <SuccessMessage>Email Updated.</SuccessMessage>}
        </div>
      </Row>
    </FormSection>
  );
};
